import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Chip,
  Stack,
  Button,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import EastIcon from '@mui/icons-material/East';


const classData = [
  {
    title: "Julia yoga",
    desc: "Julia Yoga is a space dedicated to helping you achieve balance, strength, and inner peace through mindful practice.",
    level: "Beginner",
    duration: "30 minutes",
    img: "/images/class1.jpg",
  },
  {
    title: "Pilates yoga",
    desc: "Classes for all levels, from beginners to advanced. Enjoy various styles like Hatha, Vinyasa, and Yin Yoga.",
    level: "Mid Level",
    duration: "30 minutes",
    img: "/images/class2.jpg",
  },
  {
    title: "Ramon meditation",
    desc: "Pilates Yoga combines core-strengthening and mindful movement to improve flexibility, posture, and overall well-being.",
    level: "Advanced",
    duration: "1 hour",
    img: "/images/class3.jpg",
  },
   {
    title: " Meditation",
    desc: "Pilates Yoga combines core-strengthening and mindful movement to improve flexibility, posture, and overall well-being.",
    level: "Advanced",
    duration: "1 hour",
    img: "/images/class4.webp",
  },
];

const RecentClasses = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 8 },
        bgcolor: "#fff",
        fontFamily: "Poppins, sans-serif",
        textAlign: "start",
      }}
    >
      {/* Section Header */}
      <Typography
        variant="body2"
        sx={{
          color: "#666",
          mb: 1,
          letterSpacing: 1,
          
        }}
      >
       ➜ Our Class
      </Typography>
      <Typography
        variant="h4"
        sx={{
         
          mb: 2,
          color: "#111",
          fontSize: { xs: "1.8rem", md: "2.4rem" },
        }}
      >
        Explore our recent classes
      </Typography>
      <Typography
        variant="body1"
        sx={{
            textAlign:"start",
          color: "#666",
          maxWidth: 600,
          
          lineHeight: 1.7,
          mb: 8,
        }}
      >
        Check out my latest classes designed to boost strength, flexibility,
        and well-being. Each session is thoughtfully crafted to guide you
        through effective exercises.
      </Typography>

      {/* Cards Grid */}
      <Grid container spacing={4} justifyContent="start">
        {classData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: "20px",
                width:320,
                background:"#f3f3f3ea",
                boxShadow: "none",
                overflow: "hidden",
              
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
                },
              }}
            >
              <Box sx={{ position: "relative",p:1 }}>
                <CardMedia
                  component="img"
                  image={item.img}
                  alt={item.title}
                  sx={{
                    height: 260,
                    objectFit: "cover",
                    borderRadius: "15px",
                  }}
                />

                {/* Tags (Top Left Corner) */}
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    position: "absolute",
                    top: 15,
                    left: 15,
                  }}
                >
                  <Chip
                    icon={<EmojiEventsIcon sx={{ fontSize: "1rem" }} />}
                    label={item.level}
                    size="small"
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      fontWeight: 500,
                      borderRadius: "8px",
                    }}
                  />
                  <Chip
                    icon={<AccessTimeIcon sx={{ fontSize: "1rem" }} />}
                    label={item.duration}
                    size="small"
                    sx={{
                      bgcolor: "#fff",
                      color: "#000",
                      fontWeight: 500,
                      borderRadius: "8px",
                    }}
                  />
                </Stack>
              </Box>

              {/* Card Content */}
              <CardContent sx={{ textAlign: "left", p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    
                    mb: 1,
                    color: "#111",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#555",
                    lineHeight: 1.6,
                  }}
                >
                  {item.desc}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* View All Button */}
      <Box sx={{ mt: 6,display:"flex",justifyContent:"center" }}>
    
            {/* CTA Button */}
       <Button
      variant="contained"
      sx={{
        backgroundColor: "#000000ff",
        color: "#ffffffff",
        borderRadius: "50px",
        px:1,
        textTransform: "none",
        fontWeight: 500,
        fontSize: { xs: "0.9rem", md: "1rem" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
      
      }}
    >
      <Typography sx={{paddingLeft:1}}> View all class</Typography>
      <Box
        sx={{
          backgroundColor: "#ffffffff",
          borderRadius: "50%",
          width: { xs: 30, md: 34 },
          height: { xs: 30, md: 34 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EastIcon sx={{ color: "#000000ff", fontSize: "1.1rem" }} />
      </Box>
    </Button>
      </Box>
    </Box>
  );
};

export default RecentClasses;
